
export const getPreferredCurrencyCode = () => {
    const search = new window.URLSearchParams(window.location.search);
    return search.get('currencyCode') || search.get('currency_code');
};
